/* eslint-disable jsx-a11y/media-has-caption */

import React, { useState, useEffect, useRef } from 'react';
import { useTheme } from '~/contexts/ThemeContext'
import { useSiteVideoQuery } from "~/hooks/useSiteVideoQuery"
import { inViewPartLarge } from '~/utils/helpers'

const VideoNoControl = ({ handle, par_classes, type=false }) => {
  const { isMobile } = useTheme()

  const video_item = useSiteVideoQuery(handle)
  
  const [initHeight, setInitHeight] = useState('50vh')
  const [video, setVideo] = useState(null)
  const [player, setPlayer] = useState(null)

  const wrapRef = useRef(null)
  const videoRef = useRef(null)
  const videojs = ((typeof window !== 'undefined') && window.videojs) || null

  const checkScroll = (e) => {
    if (!player) return
    const el = videoRef.current
    if (!el || !inViewPartLarge) return

    const is_inview = inViewPartLarge(el)
    if (!player) return
    
    if (is_inview && player.paused()) (isMobile && el) ? el.play() : player.play()
    if (!is_inview) (isMobile && el) ? el.pause() : player.pause()
  }

  useEffect(() => {
    if (isMobile !== null && isMobile) setInitHeight('70vh')
    return () => {
      if (player) {
        player.dispose();
      }
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (isMobile === null) return
    setVideo(video_item)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [handle, isMobile])

  useEffect(() => {
    if (!player) return
    const el = wrapRef.current
    player.on('loadeddata', function () {
      if (el) el.style.minHeight = null
    })

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [player])

  useEffect(() => {
    if (!videojs) return
    if (!video) return
    
    let vid_el = videoRef.current
    if (player) {
      player.dispose()
      const videoElement = document.createElement("video")
      videoElement.classList.add('video-js');
      wrapRef.current.appendChild(videoElement)
      vid_el = wrapRef.current.querySelector('video')
    }

    const media = video.media
    const options = {
      autoplay: true,
      controls: false,
      children: ['mediaLoader', 'posterImage'],
      setPlaysinline: true,
      playsinline: true,
      muted: true,
      loop: true,
      preferFullWindow: false,
      sources: media.sources.filter(x => x.mimeType === 'application/x-mpegURL').map((x) => {
        return {src: x.url, type: x.mimeType}
      })
    }

    if (media.src) {
      options['poster'] = media.src
    }

    setPlayer(videojs(vid_el, options))
    videoRef.current = vid_el

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [video])


  useEffect(() => {
    window.addEventListener('scroll', checkScroll, { passive: true })
    return () => {
      window.removeEventListener('scroll', checkScroll)
    }
  })

  return (
    <figure 
      ref={wrapRef}
      className={par_classes ? `${par_classes}` : undefined}
      style={{minHeight: initHeight}}
    >
      {video && (
        <video ref={videoRef} className="video-js" vid={handle} />
      )}
    </figure>
  );
};

export default VideoNoControl

